module.exports = __webpack_public_path__ + "img/environmental.898a15aa.jpg";